if (!customElements.get('zelink-product-showcase')) {
  customElements.define('zelink-product-showcase', class extends HTMLElement {
    static openingHandled = false;

    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.frame = 0;
      this.galleryFrame = 0;
      this.gallery = this.querySelector('[data-zsh-gallery-track]');
      this.gallerySlides = Array.from(this.querySelectorAll('[data-zsh-gallery-slide]'));
      this.galleryThumbs = Array.from(this.querySelectorAll('[data-zsh-gallery-thumb]'));
      this.galleryIndex = 0;
      this.track = this.querySelector('[data-zsh-reels]');
      this.reels = Array.from(this.querySelectorAll('[data-zsh-reel]'));
      this.videos = Array.from(this.querySelectorAll('video'));
      this.previous = this.querySelector('[data-zsh-prev]');
      this.next = this.querySelector('[data-zsh-next]');
      this.status = this.querySelector('[data-zsh-status]');
      this.form = this.querySelector('[data-zsh-form]');
      this.dialog = this.querySelector('[data-zsh-order-dialog]');
      this.hero = this.querySelector('[data-zsh-hero]');
      this.sticky = this.querySelector('[data-zsh-sticky]');
      this.current = Math.floor(this.reels.length / 2);
      this.sound = this.querySelector('[data-zsh-sound]');
      this.soundEnabled = false;
      this.navPanels = Array.from(this.querySelectorAll('[data-zsh-nav-panel]'));
      const signal = this.controller.signal;
      this.offerDeadline = Date.parse(this.dataset.offerEndsAt || '');
      if (Number.isFinite(this.offerDeadline)) {
        this.countdownFields = ['hours', 'minutes', 'seconds'].map((unit) => this.querySelector(`[data-zsh-${unit}]`));
        this.tickOffer();
        if (this.offerDeadline > Date.now()) this.offerTimer = window.setInterval(() => this.tickOffer(), 1000);
        document.addEventListener('visibilitychange', () => this.tickOffer(), { signal });
        window.addEventListener('pageshow', () => this.tickOffer(), { signal });
      }

      this.addEventListener('click', (event) => {
        if (!(event.target instanceof Element)) return;
        const nativeBuy = event.target.closest('a[href="/rsi-btn-hook"], ._rsi-buy-now-button');
        if (nativeBuy && this.contains(nativeBuy)) {
          if (!this.canBuy()) {
            event.preventDefault();
            event.stopImmediatePropagation();
          } else if (nativeBuy.matches('a[href="/rsi-btn-hook"]')) {
            event.preventDefault();
          }
          return;
        }
        const trigger = event.target.closest('[data-zsh-order]');
        if (trigger && this.contains(trigger)) {
          event.preventDefault();
          if (this.canBuy()) {
            const hook = this.form?.querySelector('.zsh-buy ._rsi-buy-now-button') || this.form?.querySelector('.zsh-buy a[href="/rsi-btn-hook"]');
            if (hook && hook !== trigger) hook.click();
          } else if (this.dataset.previewMode === 'true') {
            this.openPreview(trigger);
          }
        }
        if (event.target.closest('[data-zsh-close]')) this.closePreview();
      }, { capture: true, signal });
      this.form?.addEventListener('submit', (event) => {
        if (!this.canBuy()) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, { capture: true, signal });
      this.galleryThumbs.forEach((thumb, index) => thumb.addEventListener('click', () => this.showGallery(index), { signal }));
      this.querySelector('[data-zsh-gallery-prev]')?.addEventListener('click', () => this.showGallery(this.galleryIndex - 1), { signal });
      this.querySelector('[data-zsh-gallery-next]')?.addEventListener('click', () => this.showGallery(this.galleryIndex + 1), { signal });
      this.gallery?.addEventListener('scroll', () => {
        if (this.galleryFrame) return;
        this.galleryFrame = requestAnimationFrame(() => { this.galleryFrame = 0; this.updateGallery(); });
      }, { passive: true, signal });
      this.querySelector('[data-zsh-gallery]')?.addEventListener('keydown', (event) => {
        if (event.target.closest('video') || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        this.showGallery(this.galleryIndex + (event.key === 'ArrowRight' ? 1 : -1));
      }, { signal });
      window.addEventListener('scroll', () => this.updateSticky(), { passive: true, signal });
      this.updateGallery();
      this.previous?.addEventListener('click', () => this.goTo(this.current - 1), { signal });
      this.next?.addEventListener('click', () => this.goTo(this.current + 1), { signal });
      this.track?.addEventListener('pointerdown', (event) => {
        if (event.isPrimary) this.swipeStart = { x: event.clientX, y: event.clientY, id: event.pointerId };
      }, { passive: true, signal });
      this.track?.addEventListener('pointerup', (event) => {
        if (!this.swipeStart || this.swipeStart.id !== event.pointerId) return;
        const dx = event.clientX - this.swipeStart.x;
        const dy = event.clientY - this.swipeStart.y;
        this.swipeStart = null;
        if (Math.abs(dx) > 30 && Math.abs(dx) > Math.abs(dy)) {
          this.lastSwipe = performance.now();
          this.goTo(this.current + (dx < 0 ? 1 : -1));
        }
      }, { passive: true, signal });
      this.track?.addEventListener('pointercancel', () => { this.swipeStart = null; }, { passive: true, signal });
      this.reels.forEach((reel, index) => reel.addEventListener('click', () => {
        if (this.lastSwipe && performance.now() - this.lastSwipe < 400) return;
        if (index !== this.current) this.goTo(index);
      }, { signal }));
      this.sound?.addEventListener('click', () => {
        const video = this.reels[this.current]?.querySelector('video');
        if (!video) return;
        this.soundEnabled = !this.soundEnabled;
        video.muted = !this.soundEnabled;
        this.updateSound();
      }, { signal });
      this.querySelectorAll('[data-zsh-compare-range]').forEach((input) => input.addEventListener('input', () => {
        const comparison = input.closest('[data-zsh-compare]');
        if (comparison) comparison.style.setProperty('--zsh-compare', String(Math.min(100, Math.max(0, Number(input.value)))) + '%');
      }, { signal }));
      this.navPanels.forEach((panel) => panel.addEventListener('toggle', () => {
        if (panel.open) this.navPanels.forEach((other) => { if (other !== panel) other.open = false; });
      }, { signal }));
      document.addEventListener('click', (event) => {
        this.navPanels.forEach((panel) => { if (!panel.contains(event.target)) panel.open = false; });
      }, { signal });
      this.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        this.navPanels.forEach((panel) => {
          if (panel.open) { panel.open = false; panel.querySelector('summary')?.focus(); }
        });
      }, { signal });
      this.track?.addEventListener('keydown', (event) => {
        if (event.altKey || event.ctrlKey || event.metaKey || event.target.closest('video,input,select,textarea')) return;
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        let index = this.current;
        if (event.key === 'ArrowRight') index += rtl ? -1 : 1;
        else if (event.key === 'ArrowLeft') index += rtl ? 1 : -1;
        else if (event.key === 'Home') index = 0;
        else if (event.key === 'End') index = this.reels.length - 1;
        else return;
        event.preventDefault();
        this.goTo(index);
      }, { signal });
      this.addEventListener('keydown', (event) => {
        const button = event.target.closest('.zsh-buy ._rsi-buy-now-button');
        if (button && button.tagName !== 'BUTTON' && button.tagName !== 'A' && (event.key === 'Enter' || event.key === ' ')) {
          event.preventDefault();
          button.click();
        }
      }, { signal });

      this.videos.forEach((video) => {
        video.autoplay = false;
        video.removeAttribute('autoplay');
        video.pause();
        video.muted = true;
      });
      this.addEventListener('play', (event) => {
        if (!(event.target instanceof HTMLVideoElement)) return;
        const playing = event.target;
        this.videos.forEach((video) => { if (video !== playing) video.pause(); });
        if (document.hidden) playing.pause();
        const index = this.reels.indexOf(playing.closest('[data-zsh-reel]'));
        if (index >= 0) {
          this.current = index;
          this.updateReels(false);
        }
      }, { capture: true, signal });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.pauseVideos();
      }, { signal });
      window.addEventListener('pagehide', () => this.pauseVideos(), { signal });
      window.addEventListener('resize', () => { this.goTo(this.current, false); this.showGallery(this.galleryIndex, false); }, { passive: true, signal });
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.target === this.hero) this.updateSticky();
            else if (!entry.isIntersecting || entry.intersectionRatio < 0.1) entry.target.pause();
          });
        }, { threshold: [0, 0.1] });
        this.videos.forEach((video) => this.observer.observe(video));
        if (this.hero) this.observer.observe(this.hero);
      } else {
        window.addEventListener('scroll', () => this.scheduleUpdate(), { passive: true, signal });
      }
      if ('ResizeObserver' in window && this.track) {
        this.resizeObserver = new ResizeObserver(() => this.goTo(this.current, false));
        this.resizeObserver.observe(this.track);
      }

      this.dialog?.addEventListener('click', (event) => {
        if (event.target !== this.dialog) return;
        const bounds = this.dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.closePreview();
      }, { signal });
      this.dialog?.addEventListener('cancel', (event) => {
        event.preventDefault();
        this.closePreview();
      }, { signal });
      this.dialog?.addEventListener('close', () => {
        if (this.returnFocus?.isConnected) this.returnFocus.focus({ preventScroll: true });
        this.returnFocus = null;
      }, { signal });
      this.buttonObserver = new MutationObserver(() => this.enhanceButtons());
      this.buttonObserver.observe(this, { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] });
      this.enhanceButtons();
      this.goTo(this.current, false);
      this.updateSticky();
      this.restoreOpeningPosition(signal);
    }

    showGallery(index, animate = true) {
      if (!this.gallery || !this.gallerySlides.length) return;
      this.galleryIndex = (index + this.gallerySlides.length) % this.gallerySlides.length;
      const track = this.gallery.getBoundingClientRect();
      const slide = this.gallerySlides[this.galleryIndex].getBoundingClientRect();
      this.gallery.scrollTo({ left: this.gallery.scrollLeft + slide.left - track.left, behavior: animate && !window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'instant' });
      this.pauseVideos();
      const thumb = this.galleryThumbs[this.galleryIndex];
      const strip = thumb?.parentElement;
      if (thumb && strip) {
        const rect = thumb.getBoundingClientRect();
        const bounds = strip.getBoundingClientRect();
        if (rect.left < bounds.left || rect.right > bounds.right) strip.scrollTo({ left: strip.scrollLeft + rect.left - bounds.left, behavior: 'smooth' });
      }
    }

    updateGallery() {
      if (!this.gallery || !this.gallerySlides.length) return;
      const bounds = this.gallery.getBoundingClientRect();
      const center = bounds.left + bounds.width / 2;
      let distance = Infinity;
      this.gallerySlides.forEach((slide, index) => {
        const rect = slide.getBoundingClientRect();
        const difference = Math.abs(rect.left + rect.width / 2 - center);
        if (difference < distance) { distance = difference; this.galleryIndex = index; }
      });
      this.galleryThumbs.forEach((thumb, index) => thumb.setAttribute('aria-pressed', String(index === this.galleryIndex)));
      this.gallerySlides.forEach((slide, index) => { if (index !== this.galleryIndex) slide.querySelectorAll('video').forEach(video => video.pause()); });
      const status = this.querySelector('[data-zsh-gallery-status]');
      const label = String(this.galleryIndex + 1) + ' / ' + String(this.gallerySlides.length);
      if (status && status.textContent !== label) status.textContent = label;
    }

    tickOffer() {
      if (!Number.isFinite(this.offerDeadline)) return;
      const remaining = Math.max(0, Math.ceil((this.offerDeadline - Date.now()) / 1000));
      const values = [Math.floor(remaining / 3600), Math.floor((remaining % 3600) / 60), remaining % 60];
      this.countdownFields.forEach((field, index) => {
        if (!field) return;
        const value = String(values[index]).padStart(2, '0');
        if (field.textContent !== value) field.textContent = value;
      });
      if (remaining > 0 || this.offerExpired) return;
      this.offerExpired = true;
      window.clearInterval(this.offerTimer);
      this.dataset.canBuy = 'false';
      this.dataset.previewMode = 'false';
      const ended = this.dataset.offerEndedLabel;
      const title = this.querySelector('[data-zsh-offer-title]');
      if (title) title.textContent = ended;
      this.querySelectorAll('[data-zsh-order], .zsh-buy ._rsi-buy-now-button, .zsh-buy a[href="/rsi-btn-hook"]').forEach((button) => {
        button.setAttribute('aria-disabled', 'true');
        if ('disabled' in button) button.disabled = true;
        else { button.tabIndex = -1; button.setAttribute('data-offer-expired-link', ''); }
        if (!button.classList.contains('zsh-nav-bag')) button.textContent = ended;
      });
      this.closePreview();
      this.updateSticky();
    }

    canBuy() {
      return this.dataset.canBuy === 'true' && this.dataset.pricePending !== 'true' && (!Number.isFinite(this.offerDeadline) || Date.now() < this.offerDeadline);
    }

    openPreview(trigger) {
      if (this.canBuy() || this.dataset.previewMode !== 'true' || !this.dialog || this.dialog.open || typeof this.dialog.showModal !== 'function') return;
      this.returnFocus = trigger;
      this.dialog.querySelectorAll('input,select,textarea,button[type="submit"]').forEach((control) => { control.disabled = true; });
      this.pauseVideos();
      this.dialog.showModal();
      this.dialog.querySelector('[data-zsh-close]')?.focus({ preventScroll: true });
    }

    closePreview() {
      if (this.dialog?.open) this.dialog.close();
    }

    pauseVideos(except) {
      this.videos.forEach((video) => { if (video !== except && !video.paused) video.pause(); });
    }

    goTo(index) {
      if (!this.track || !this.reels.length || !Number.isFinite(index)) return;
      this.current = Math.max(0, Math.min(this.reels.length - 1, Math.trunc(index)));
      this.updateReels();
    }

    updateReels() {
      this.reels.forEach((reel, index) => {
        const active = index === this.current;
        const offset = index - this.current;
        reel.classList.toggle('is-active', active);
        reel.dataset.position = String(offset);
        reel.hidden = Math.abs(offset) > 2;
        reel.querySelectorAll('video').forEach((video) => {
          if (this.sound) video.muted = !this.soundEnabled;
          if (!active) video.pause();
        });
      });
      if (this.previous) this.previous.disabled = this.current === 0;
      if (this.next) this.next.disabled = this.current === this.reels.length - 1;
      const label = String(this.current + 1) + ' / ' + String(this.reels.length);
      if (this.status && this.status.textContent !== label) this.status.textContent = label;
      this.updateSound();
    }

    updateSound() {
      if (!this.sound) return;
      this.sound.disabled = !this.reels[this.current]?.querySelector('video');
      this.sound.setAttribute('aria-pressed', String(this.soundEnabled));
      this.sound.setAttribute('aria-label', this.soundEnabled ? this.sound.dataset.soundOff : this.sound.dataset.soundOn);
    }

    updateSticky() {
      if (this.sticky) this.sticky.hidden = !this.hero || (window.matchMedia('(max-width: 749px)').matches ? window.scrollY < 120 : this.hero.getBoundingClientRect().bottom > 0) || (!this.canBuy() && this.dataset.previewMode !== 'true');
    }

    scheduleUpdate() {
      if (this.frame || !this.controller) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = 0;
        this.updateReels();
        this.updateSticky();
      });
    }

    enhanceButtons() {
      this.querySelectorAll('.zsh-buy ._rsi-buy-now-button').forEach((button) => {
        ['background', 'background-color', 'background-image', 'color', 'border', 'border-radius', 'box-shadow', 'font', 'font-family', 'font-size', 'font-weight', 'line-height'].forEach((property) => {
          if (button.style.getPropertyValue(property)) button.style.removeProperty(property);
        });
        if (button.tagName !== 'BUTTON' && button.tagName !== 'A') {
          button.setAttribute('role', 'button');
          button.tabIndex = this.canBuy() ? 0 : -1;
        }
        if (!this.canBuy()) button.setAttribute('aria-disabled', 'true');
        else button.removeAttribute('aria-disabled');
      });
    }

    restoreOpeningPosition(signal) {
      if (this.constructor.openingHandled || window.Shopify?.designMode || window.location.hash) return;
      const navigation = performance.getEntriesByType('navigation')[0];
      if (!navigation || !['navigate', 'reload'].includes(navigation.type)) return;
      this.constructor.openingHandled = true;
      if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
      let interacted = false;
      const markInteraction = () => { interacted = true; };
      ['pointerdown', 'touchstart', 'keydown', 'wheel'].forEach((name) => window.addEventListener(name, markInteraction, { once: true, passive: true, signal }));
      const reset = (event) => {
        if (event?.persisted || interacted || window.location.hash || !this.controller) return;
        window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
      };
      const settleOpening = (event) => {
        reset(event);
        requestAnimationFrame(() => requestAnimationFrame(() => reset(event)));
      };
      settleOpening();
      window.addEventListener('pageshow', settleOpening, { once: true, signal });
      if (document.readyState !== 'complete') window.addEventListener('load', settleOpening, { once: true, signal });
    }

    disconnectedCallback() {
      if (!this.controller) return;
      this.closePreview();
      window.clearInterval(this.offerTimer);
      this.offerExpired = false;
      this.controller.abort();
      this.controller = null;
      this.observer?.disconnect();
      this.resizeObserver?.disconnect();
      this.buttonObserver?.disconnect();
      cancelAnimationFrame(this.frame);
      cancelAnimationFrame(this.galleryFrame);
      this.frame = 0;
      this.pauseVideos();
      if (this.sticky) this.sticky.hidden = true;
      this.returnFocus = null;
    }
  });
}
